import React from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { AtomProps } from '@/uiKit/atoms/utils/AtomTypes.ts';
import { DateUtils, SupportedDate } from '@/utils/dateUtils.ts';

export type BaseAgeProps = {
  birthDate: SupportedDate;
};

export type AgeProps = AtomProps<BaseAgeProps>;

export const Age: React.FC<AgeProps> = ({ birthDate, ...props }) => {
  const { t } = useTranslation();

  if (!birthDate) {
    return null;
  }

  return (
    <Typography variant="body" {...props}>
      {t('pages.patientMonitoring.patient.age', {
        age: DateUtils.age(birthDate),
      })}
    </Typography>
  );
};
